import { KeyValue } from '@/main/models/common';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import {
  ProcurementReportScheduleSaveRequest,
  ProcurementReportScheduleSearchGridRequest
} from '@/main/models/request';
import {
  ProcurementReportScheduleGridResponse,
  ProcurementReportScheduleResponse
} from '@/main/models/response';
import { AxiosResponse } from 'axios';

export abstract class IProcurementReportScheduleAPI {
  abstract procurementReportScheduleSearchGrid(
    request: ProcurementReportScheduleSearchGridRequest
  ): Promise<
    AxiosResponse<PaginationResponse<ProcurementReportScheduleGridResponse[]>>
  >;
  abstract saveProcurementReportSchedule(
    request: ProcurementReportScheduleSaveRequest
  ): Promise<AxiosResponse<Result<ProcurementReportScheduleResponse>>>;
  abstract removeProcurementReportSchedule(
    request: string
  ): Promise<AxiosResponse<Result<boolean>>>;
  abstract getProcurementReportSchedule(
    request: string
  ): Promise<AxiosResponse<Result<ProcurementReportScheduleResponse>>>;
}
